import type { FunctionComponent, PropsWithChildren } from "react"

import classNames from "classnames"
import dynamic from "next/dynamic"

import { Paper, PAPER_RADIUS } from "@jobteaser/ui-kit/components/Paper/Paper"

import { useCompanyFetch } from "@/modules/companies/client/hooks/useCompanyFetch"

import styles from "./Certification.module.css"

type CertificationProps = { className?: string } & PropsWithChildren

const GreatPlaceToWorkDynamic = dynamic(
  () => import("./GreatPlaceToWork/GreatPlaceToWork").then(mod => mod.GreatPlaceToWork),
  { ssr: false }
)

const ChooseMyCompanyDynamic = dynamic(
  () => import("./ChooseMyCompany/ChooseMyCompany").then(mod => mod.ChooseMyCompany),
  { ssr: false }
)

const GlassdoorDynamic = dynamic(() => import("./Glassdoor/Glassdoor").then(mod => mod.Glassdoor), { ssr: false })

export const Certification: FunctionComponent<CertificationProps> = ({ className }) => {
  const { dataCompany } = useCompanyFetch()
  const companyPage = dataCompany?.page

  const greatPlaceToWorkPermalink = companyPage?.greatPlaceToWorkPermalink
  const greatPlaceToWorkYear = companyPage?.greatPlaceToWorkYear || 0
  const lastYear = new Date().getFullYear() - 1
  const displayGreatPlaceToWork = !!greatPlaceToWorkPermalink && greatPlaceToWorkYear >= lastYear

  const displayChooseMyCompany = !!companyPage?.chooseMyCompany
  const displayGlassdoor = !!dataCompany?.page?.glassdoorId
  const displayCertification = displayGreatPlaceToWork || displayChooseMyCompany || displayGlassdoor

  return (
    (displayCertification && (
      <Paper
        className={classNames(className, styles.container)}
        hasBorder
        noShadow
        smallSpacing
        radius={PAPER_RADIUS.DEFAULT}
        data-testid="company_certification_block"
      >
        {displayGreatPlaceToWork && <GreatPlaceToWorkDynamic />}
        {displayChooseMyCompany && <ChooseMyCompanyDynamic />}
        {displayGlassdoor && <GlassdoorDynamic />}
      </Paper>
    )) ||
    null
  )
}
